import { render, staticRenderFns } from "./StudyProgramGroupSelector.vue?vue&type=template&id=28400491&scoped=true&"
import script from "./StudyProgramGroupSelector.vue?vue&type=script&lang=js&"
export * from "./StudyProgramGroupSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28400491",
  null
  
)

export default component.exports